import { FilterConfig, FilterQuery } from '@monolog/shared/types';

// Create new enums for filter routes here
export enum FilterType {
  storeCredit = 'STORE_CREDIT',
  claim = 'CLAIM',
  gallery = 'GALLERY',
  order = 'ORDER',
  payout = 'PAYOUT',
  return = 'RETURN',
  product = 'PRODUCT',
  warranty = 'WARRANTY',
  claimAutomation = 'CLAIM_AUTOMATION',
  claimAutomationStores = 'CLAIM_AUTOMATION_STORES',
  claimAutomationModels = 'CLAIM_AUTOMATION_MODELS',
  claimAutomationSentiment = 'CLAIM_AUTOMATION_SENTIMENT',
  claimAutomationControlPanel = 'CLAIM_AUTOMATION_CONTROL_PANEL',
  claimAutomationAiSpendFeatures = 'CLAIM_AUTOMATION_AI_SPEND_FEATURES',
  claimAutomationAiSpendModels = 'CLAIM_AUTOMATION_AI_SPEND_MODELS',
  claimAutomationAiSpendStores = 'CLAIM_AUTOMATION_AI_SPEND_STORES',
  reviews = 'REVIEWS',
}

export type FilterOptions = {
  startTitle?: string;
  hideAddButton?: boolean;
  hideClearButton?: boolean;
  hideDeleteButton?: boolean; // we can add string[] for filter fields for granular control
  hideOperator?: boolean; // we can add string[] for filter fields for granular control
  addFilterFn?: (availableFilters: FilterConfig[], appliedFilters: FilterQuery[]) => FilterQuery[];
};
